import React, { useState } from 'react';

const RemoveFromCartButton = ({ onClick }: { onClick: () => Promise<void> }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <button
      aria-label="Remove Item"
      className="remove__from__cart"
      type="button"
      disabled={isLoading}
      onClick={async () => {
        setIsLoading(true);
        await onClick();
        setIsLoading(false);
      }}
    >
      <span className="alo-cross-primary-icon"></span>
    </button>
  );
};

export default RemoveFromCartButton;
